"use client";

import { FormEvent, useState } from "react";
import { accountError, apiBaseUrl, csrfHeaders } from "@/lib/browser-api";

export default function PasswordForm() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string>();
  const [success, setSuccess] = useState(false);
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); const form = event.currentTarget; const values = new FormData(form);
    setSuccess(false); setMessage(undefined);
    if (values.get("new_password") !== values.get("confirmation")) {
      setMessage("Die neuen Passwörter stimmen nicht überein."); return;
    }
    setBusy(true);
    try {
      const response = await fetch(`${apiBaseUrl}/api/auth/password`, {
        method:"POST", credentials:"include", headers:{"Content-Type":"application/json", ...csrfHeaders()},
        body:JSON.stringify({current_password:values.get("current_password"),new_password:values.get("new_password")}),
      });
      if (response.ok) {
        form.reset(); setSuccess(true);
        setMessage("Dein Passwort wurde geändert. Alle bisherigen Sitzungen sind abgemeldet; diese Sitzung wurde sicher erneuert.");
      } else setMessage(response.status === 400 ? "Das aktuelle Passwort stimmt nicht." : accountError(response.status));
    } catch { setMessage("Die Verbindung ist unterbrochen. Bitte versuche es erneut."); }
    finally { setBusy(false); }
  }
  return <section className="password-section" aria-labelledby="password-heading">
    <h2 id="password-heading">Passwort ändern</h2>
    <p>Bestätige dein aktuelles Passwort. Mit der Änderung werden alle bisherigen Sitzungen dieses Kontos ungültig.</p>
    <form className="account-password-form" method="post" onSubmit={submit}>
      <label>Aktuelles Passwort<input type="password" name="current_password" autoComplete="current-password" required maxLength={128}/></label>
      <label>Neues Passwort<input type="password" name="new_password" autoComplete="new-password" required minLength={12} maxLength={128}/></label>
      <label>Neues Passwort wiederholen<input type="password" name="confirmation" autoComplete="new-password" required minLength={12} maxLength={128}/></label>
      <p className="quality-note">12–128 Zeichen. Verwende ein eigenes, langes Passwort; Leerzeichen innerhalb einer Passphrase sind erlaubt.</p>
      <button type="submit" className="button primary" disabled={busy}>{busy ? "Wird geändert …" : "Passwort sicher ändern"}</button>
      {message ? <p className={success ? "form-message" : "job-error"} role={success ? "status" : "alert"}>{message}</p> : null}
    </form>
  </section>;
}
